"use strict";
/*
 * Copyright (C) 2022 JET PROTOCOL HOLDINGS, LLC.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JET_REWARDS_ID = exports.DistributionYield = exports.DistributionKind = exports.Distribution = exports.RewardsClient = exports.Award = exports.Airdrop = void 0;
const web3_js_1 = require("@solana/web3.js");
var airdrop_1 = require("./airdrop");
Object.defineProperty(exports, "Airdrop", { enumerable: true, get: function () { return airdrop_1.Airdrop; } });
var award_1 = require("./award");
Object.defineProperty(exports, "Award", { enumerable: true, get: function () { return award_1.Award; } });
var client_1 = require("./client");
Object.defineProperty(exports, "RewardsClient", { enumerable: true, get: function () { return client_1.RewardsClient; } });
var distribution_1 = require("./distribution");
Object.defineProperty(exports, "Distribution", { enumerable: true, get: function () { return distribution_1.Distribution; } });
Object.defineProperty(exports, "DistributionKind", { enumerable: true, get: function () { return distribution_1.DistributionKind; } });
Object.defineProperty(exports, "DistributionYield", { enumerable: true, get: function () { return distribution_1.DistributionYield; } });
exports.JET_REWARDS_ID = new web3_js_1.PublicKey("JET777rQuPU8BatFbhp6irc1NAbozxTheBqNo25eLQP");
//# sourceMappingURL=index.js.map